import {BaseSyntheticEvent, FC, useEffect, useMemo, useState} from 'react'
import useAuth from '../../../../../hooks/useAuth'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {i18n} from '../../../../../translate/i18n'
import {useProduct} from './factory/useProduct'
import {ModularDataTable} from '../../../../../components/ModularDataTable'
import {createActions} from './factory/actionsFactory'
import usePluginsSpace from '../../../../../hooks/usePluginSpace'
import useModals from '../../../../../hooks/useModals'
import {useNavigate} from 'react-router-dom'
import {createColumns} from './factory/generateColumns'
import {Loading} from '../../../../../components/Loading/Loading'
import {BreadCrumbs} from '../../../../../components/BreadCrumbs/breadCrumbrs'
import {FilterOptions} from './components/filterOptions'
import {PluginconfigType} from './type'
import {OptionsProduct} from './components/optionsProduct'
import {ModalDelete} from '../../../../../components/Modals/General/ModalDelete/ModalDelete'
import {ModalWrapper} from '../../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import Swal from 'sweetalert2'
import {POST, PUT} from '../../../../../services/api'
import {Button} from '../../../../../components/Button/Button'
import {Input} from '../../../../../components/Input/Input'
import {LoteOptions} from './components/loteOptions'

const ProdutosContent: FC = () => {
  const navigate = useNavigate()
  const {loginInfo} = useAuth()
  const {showDeleteModal, showWrapperModal} = useModals()
  const {pluginSpace} = usePluginsSpace()
  const [fileToImport, setFileToImport] = useState<File | null>(null)
  const isWholeSaler = Boolean(pluginSpace?.wholeSaler)
  const {
    products,
    tableLoading,
    productFilters,
    loading,
    pagination,
    sorting,
    categories,
    registeredGroups,
    setTableLoading,
    setLoading,
    getProducts,
    setProductId,
    handleDataChange,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
    getCategories,
    getCustomersGroups,
    deleteProduct,
  } = useProduct()
  const {integrations} = usePluginsSpace()
  const {verifyAdm, verifyCommonAdmin} = useAuth()
  const integrationTemplateIds = [23, 15, 45, 48, 104]
  const matchedIntegrations = integrations.filter((pluginconfig: any) => {
    if (!integrationTemplateIds.includes(pluginconfig?.plugintemplateId)) {
      return false
    }

    const able = pluginconfig?.content?.able
    return able === '1' || able === 1
  })

  const isAdmin = verifyCommonAdmin() && verifyAdm()
  const canManageSaleDates =
    loginInfo?.profile === 'admin' || loginInfo?.profile === 'owner'
  const hasIntegration = matchedIntegrations.length > 0

  useEffect(() => {
    console.info('[Produtos/newIndex] Integracoes encontradas para hasIntegration:', {
      integrationTemplateIds,
      hasIntegration,
      matched: matchedIntegrations.map((item: any) => ({
        id: item.id,
        name: item.name,
        plugintemplateId: item.plugintemplateId,
        able: item?.content?.able ?? null,
      })),
    })
  }, [hasIntegration, integrations])

  async function switchStatus(params: {endpoint: string; Id: number; status: boolean}) {
    const {Id, status, endpoint} = params
    const body = {status}
    await PUT(`/${endpoint}/${Id}`, body)
  }

  const columns = useMemo(() => createColumns({switchStatus, isWholeSaler}), [])

  const actions = useMemo(
    () =>
      createActions({
        navigate,
        showDeleteModal,
        setProductId,
        isAdmin,
        plugintype: (loginInfo.plugintype as 'varejo' | 'fashion') ?? 'varejo',
      }),
    [isAdmin, loginInfo.plugintype]
  )

  const deleteAllProduct = async () => {
    try {
      setLoading(true)
      const res = await POST('product/delete-all')
      if (res.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Produtos deletados',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getProducts())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao deletar o produtos!',
        }).then(async () => await getProducts())
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao deletar o produto!',
      }).then(async () => await getProducts())
      console.log(e)
    }
  }

  async function filterProduct() {
    setTableLoading(true)

    // 1. Atualiza visualmente a paginação na tabela para voltar ao início
    handlePaginationChange({...pagination, page: 1})

    // 2. Força a requisição na API a buscar a partir da página 1
    await getProducts({page: 1})

    setTableLoading(false)
  }

  async function loadPage() {
    setLoading(true)
    await getCategories()
    if (isWholeSaler) {
      await getCustomersGroups()
    }
    await getProducts()
    setLoading(false)
  }

  function b64toBlob(base64: string, contentType: string) {
    const byteCharacters = atob(base64)
    const byteArrays = []

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512)
      const byteNumbers = new Array(slice.length)
      for (let j = 0; j < slice.length; j++) {
        byteNumbers[j] = slice.charCodeAt(j)
      }
      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    return new Blob(byteArrays, {type: contentType})
  }

  useEffect(() => {
    loadPage()
  }, [])

  const importProducts = async () => {
    try {
      if (!fileToImport) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se foi selecionado um arquivo!',
        })
        return
      }

      setLoading(true)
      const formData = new FormData()
      formData.append('file', fileToImport)

      const importRes = await POST('/product/import', formData)
      setLoading(false)

      if (importRes.success === true && !importRes.fileBase64) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Importação realizada com sucesso!',
        }).then(async () => await getProducts())
      } else if (importRes.fileBase64) {
        const blob = b64toBlob(
          importRes.fileBase64,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
        const url = window.URL.createObjectURL(blob)

        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          html: `
            <div style="margin-bottom: 1em;">
              Alguns produtos ou variações apresentaram <b>erros na importação</b>.<br>
              Você pode baixar o arquivo com os detalhes abaixo.
            </div>
            <button id="baixar-erros" class="swal2-confirm swal2-styled" style="display:inline-block; margin-right: 1em;">Baixar erros</button>
            <button id="fechar-alerta" class="swal2-cancel swal2-styled" style="display:inline-block; background:#eee; color:#333;">Fechar</button>
          `,
          showConfirmButton: false,
          didOpen: () => {
            document.getElementById('baixar-erros')?.addEventListener('click', () => {
              const a = document.createElement('a')
              a.href = url
              a.download = 'erros-importacao.xlsx'
              document.body.appendChild(a)
              a.click()
              a.remove()
              window.URL.revokeObjectURL(url)
              Swal.close()
            })
            document.getElementById('fechar-alerta')?.addEventListener('click', () => {
              Swal.close()
            })
          },
        }).then(async () => await getProducts())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao importar arquivo!',
        }).then(async () => await getProducts())
      }
    } catch (e: any) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro inesperado',
        text: e?.message || 'Ocorreu um erro inesperado',
      }).then(async () => await getProducts())
    }

    setFileToImport(null)
  }

  if (loading) {
    return <Loading />
  }

  return (
    <div className='row g-5 gx-xxl-12'>
      <div className='card card-xxl-stretch mb-5 mb-xl-12'>
        <div className='card-header py-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`smart_order.product`)}</span>
            <BreadCrumbs />
            <span className='text-muted mt-1 fw-bold fs-7'>
              {i18n.t(
                `smart_order.here_are_listed_the_products_along_with_their_respective_actions`
              )}
            </span>
          </h3>
          <OptionsProduct
            hasIntegration={hasIntegration}
            isWholeSaler={isWholeSaler}
            showWrapperModal={showWrapperModal}
            hasProduct={products.length > 0}
            deleteAllProduct={deleteAllProduct}
          />
        </div>

        <div className='card-body'>
          <FilterOptions
            productFilters={productFilters}
            handleFilterChange={handleFilterChange}
            filterProduct={filterProduct}
            categories={categories}
            registeredGroups={registeredGroups}
          />
          <LoteOptions
            isWholeSaler={isWholeSaler}
            hasIntegration={hasIntegration}
            isAdmin={isAdmin}
            canManageSaleDates={canManageSaleDates}
            pluginspaceId={loginInfo.pluginspaceId ?? undefined}
            filterProduct={filterProduct}
          />
          <ModularDataTable
            data={products}
            columns={columns}
            actions={actions}
            pagination={pagination}
            onPaginationChange={handlePaginationChange}
            sorting={sorting}
            onSortingChange={handleSortingChange}
            onDataChange={handleDataChange}
            searchable={true}
            searchPlaceholder='Pesquisar produtos...'
            loading={tableLoading}
            selectable={false}
            striped={false}
            hover={false}
            size='md'
            className='table-row-bordered table-row-gray-200'
            alterColumns
            persistPageKey='produtos'
            persistContextKey='default'
          />
        </div>
      </div>

      <ModalDelete confirmAction={() => deleteProduct()} text='delete_product_observation' />
      <ModalWrapper confirmAction={() => importProducts()}>
        {' '}
        <>
          <div className='flex-grow-1'>
            <p className='pt-4'>{i18n.t(`general.attention`)}</p>
            <p>Este modelo de planilha deve ser utilizado para importar produtos e variações.</p>
            <div style={{width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxWidth: '50em',
                  }}
                >
                  Preencha os campos conforme os cabeçalhos indicados na primeira linha da planilha.
                  Certifique-se de que os dados estejam completos e corretos antes de realizar o
                  envio.
                </div>
              </div>
            </div>
            <div className='mt-4 mb-4'>
              <Button
                text={'Modelo'}
                color='primary'
                iconColor='#FFF'
                size='small'
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  window.open('/file/modelo-produtos-variacoes.xlsx', '')
                }}
                btnClass='fw-bolder me-5'
              />
            </div>
          </div>
          <br />
          <div className='flex-grow-1 text-center'>
            <Input
              inputAttr={{
                type: 'file',
              }}
              acceptFile={'.xlsx,.xls'}
              change={(value: BaseSyntheticEvent) =>
                setFileToImport(value ? value.target.files[0] : null)
              }
            />
          </div>
        </>
      </ModalWrapper>
    </div>
  )
}

const NewProdutos: FC = () => {
  const {loginInfo} = useAuth()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`smart_order.product`),
            path: loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`smart_order.product`)}
      </PageTitle>
      <ProdutosContent />
    </>
  )
}

export {NewProdutos}
